import styled from 'styled-components';
import { colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const CardContainerSmall = styled.div<{ ignoreSize?: boolean }>`
  display: flex;
  width: ${({ ignoreSize }) => (ignoreSize ? '100%' : '296px')};
  height: ${({ ignoreSize }) => (ignoreSize ? '100%' : '356px')};
  padding-bottom: 0;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 20px;
  position: relative;
  background: ${colors.$ffffff};
  gap: 24px;
  border: 1px solid ${colors.$bebebe};
`;

export const CardContainerLarge = styled.div<{ ignoreSize?: boolean }>`
  display: flex;
  width: ${({ ignoreSize }) => (ignoreSize ? '100%' : '405px')};
  height: ${({ ignoreSize }) => (ignoreSize ? '100%' : '600px')};
  padding-bottom: 0;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 20px;
  position: relative;
  background: ${colors.$ffffff};
  gap: 24px;
`;

export const TopImageContainer = styled.div<{ ignoreSize?: boolean }>`
  width: 100%;
  height: ${({ ignoreSize }) => (ignoreSize ? '50%' : '160px')};
  background: lightgray;
  border-radius: 20px 20px 0 0;
  align-self: stretch;
  div {
    height: 100% !important;
  }
`;

export const TopImageContainerLarge = styled.div<{ ignoreSize?: boolean }>`
  width: 100%;
  height: ${({ ignoreSize }) => (ignoreSize ? '50%' : '348px')};
  background: lightgray;
  border-radius: 20px 20px 0 0;
  align-self: stretch;
  div {
    height: 100% !important;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  padding: 0 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const ContentContainerLarge = styled.div`
  display: flex;
  padding: 0 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`;

export const Title = styled.div`
  font-family: ${fonts.exbold};
  text-align: start;
  ${pxToCssFont(22, 32)};
  color: ${colors.$262626};
  /* Overflow after 3 lines */
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const TitleLarge = styled.div`
  font-family: ${fonts.exbold};
  text-align: start;
  ${pxToCssFont(28, 36)};
  color: ${colors.$262626};
  /* Overflow after 3 lines */
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Topic = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(16, 22)};
  color: ${colors.$262626};
`;

export const TopicLarge = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 24)};
  color: ${colors.$262626};
`;

export const Creator = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(16, 22)};
  color: ${colors.$7e7e7e};
`;
export const CreatorLarge = styled.div`
  font-family: ${fonts.regular};
  ${pxToCssFont(18, 24)};
  color: ${colors.$7e7e7e};
`;

export const PillElement = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 20px;
  left: 20px;
`;
